import axios from "axios";
import { TaxiCompanyList } from "../GetDirectionAndFare/models/getFareSamplesParams";
import { setTaxiEndpoint } from "../GetReservation";
import { TaxiCompanyConfigurations } from "./model/taxiCompanyConf";

interface ApiConfig {
  baseURL: string;
  timeout: number;
}

const DEFAULT_API_CONFIG: ApiConfig = {
  baseURL: process.env['REACT_APP_API_ENDPOINT'] as string,
  timeout: 60000,
};

export enum ComponentKey {
  pulldown = 'pulldown'
}

export interface GetTaxiCompanyConfParams {
  key?: string,
  companyCode?: TaxiCompanyList,
  componentKey?: ComponentKey,
  id?: string,
  language: string
}

/** タクシー会社のメタ情報取得APIを呼び出す */
export async function getTaxiCompanyConfiguration(params: GetTaxiCompanyConfParams) {
  const path = setTaxiEndpoint('get-configuration');
  const config = {
    ...DEFAULT_API_CONFIG,
  };
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
  /** axiosのインスタンス。 */
  const instance = axios.create(config);
  const response = await instance.get(path, {
    params: params
  });
  let reseponseBody: TaxiCompanyConfigurations | null = null;
  // Response結果が正常ならデータを返す
  if(response.status === 200 && response.data) {
    reseponseBody = response.data;
  }
  else {
    // エラーが発生した場合は、debugレベルでエラーログを出力するのみとする。
    // dev環境のみエラーログを出力
    if(process.env['REACT_APP_STAGE_ENV'] === 'dev') {
      console.error(response);
    }
  }
  return {
    type: 'getTaxiCompanyConfiguration',
    body: reseponseBody
  }
}
